<template>
  <div class="bgfff out_wrap">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="微信商户号" name="1">
        <div style="line-height: 22px;" class="c9 mb20">
          <div>使用说明：每次需要增加绑定APPID时请在此页面直接申请添加，平台处理后会以短信的形式通知您绑定结果。</div>
        </div>
        <div class="flex_between search">
          <div class="left flex1">
            <el-form label-width="82px" :model="form" label-suffix=":">
              <div class="form-box">
                <!-- <Comcompany :id="form.company_id" class="formItem" :label="'客户名称'" @Cchange="form.company_id = $event" /> -->
                <el-form-item label="商户号" class="formItem">
                  <el-select v-model="form.mch_id" clearable placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option v-for="(item,index) in wxOptions" :key="index" :label="item" :value="item" />
                  </el-select>
                </el-form-item>
                <el-form-item label="关键字" class="formItem">
                  <el-input v-model="form.keyword" placeholder="请输入应用名称/APPID" />
                </el-form-item>
                <el-form-item label="状态" class="formItem">
                  <el-select v-model="form.status" placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option label="待处理" value="1" />
                    <el-option label="已绑定" value="2" />
                    <el-option label="已禁用" value="3" />
                    <el-option label="已拒绝" value="-1" />
                  </el-select>
                </el-form-item>
                <div class="formItem operate">
                  <el-button type="primary" @click="query(1)">查询</el-button>
                  <el-button @click="resetForm">重置</el-button>
                  <el-button v-if="powerReg('f347014fff59ae1ac288ba25c459bb44')" type="primary" @click="add"><i class="el-icon-plus" />申请添加</el-button>
                  <el-button class="ml20" type="primary" @click="exportFn">导出</el-button>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <zf-table
          :columns="column"
          :data-source="tableList"
          :total="pages.total"
          :page-size="pages.pageSize"
          :page-num="pages.page"
          @change="handlePageChange"
        >
          <template
            slot="download_url"
            slot-scope="{ row }"
          >
            <div v-if="row.download_url" class="flex_between">
              <span :title="row.download_url" class="ellipsis">{{ row.download_url }}</span>
              <el-link v-clipboard:copy="row.download_url" v-clipboard:success="onCopy" type="primary" :underline="false" style="width:56px;flex-shrink: 0;">复制</el-link>
            </div>
            <span v-else>-</span>
          </template>
          <template
            slot="app_user_agreement_url"
            slot-scope="{ row }"
          >
            <div v-if="row.app_user_agreement_url" class="flex_between">
              <span :title="row.app_user_agreement_url" class="ellipsis">{{ row.app_user_agreement_url }}</span>
              <el-link v-clipboard:copy="row.app_user_agreement_url" v-clipboard:success="onCopy" type="primary" :underline="false" style="width:56px;flex-shrink: 0;">复制</el-link>
            </div>
            <span v-else>-</span>
          </template>
          <template
            slot="is_oauth"
            slot-scope="{ row }"
          >
            <span v-if="row.is_oauth == 1" >是</span>
            <span v-if="row.is_oauth == 0" >否</span>
          </template>
          <template
            slot="status"
            slot-scope="{ row }"
          >
            <span v-if="row.status == 1" class="wait_bg plub_width inline">待处理</span>
            <span v-if="row.status == 2" class="ableuse_bg plub_width inline">已绑定</span>
            <span v-if="row.status == 3" class="no_bg plub_width inline" style="width:74px">已禁用 <el-tooltip class="item" effect="dark" content="该APPID已被平台方禁止付款，有疑问请及时联系平台方。" placement="top-end">
              <i style="color:black;" class="el-icon-warning" />
            </el-tooltip></span>
            <span v-if="row.status == -1" class="nouse_bg plub_width inline">已拒绝</span>
          </template>
          <!-- 拒绝原因 -->
          <template
            slot="reject_msg"
            slot-scope="{ row }"
          >
            <span v-if="row.status == -1">{{ row.reject_msg }}</span>
            <span v-else>-</span>
          </template>
          <!-- 操作 -->
          <template
            slot="action"
            slot-scope="{ row }"
          >
            <a v-if="row.status == 1" class="del" @click="backout(row)">撤销</a>
            <a class="active_color" @click="app_mch_info(row)">详情</a>
          </template>
        </zf-table>
      </el-tab-pane>
      <el-tab-pane label="支付宝商户号" name="2">
        <div style="line-height: 22px;" class="c9 mb20">
          <div>使用说明：每次需要增加绑定APPID时请在此页面直接申请添加，平台处理后会以短信的形式通知您绑定结果。</div>
        </div>
        <div class="flex_between search">
          <div class="left flex1">
            <el-form label-width="82px" :model="zhiform" label-suffix=":">
              <div class="form-box">
                <!-- <Comcompany :id="zhiform.company_id" class="formItem" :label="'客户名称'" @Cchange="zhiform.company_id = $event" /> -->
                <el-form-item label="商户号" class="formItem">
                  <el-select v-model="zhiform.mch_id" clearable placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option v-for="(item,index) in aliOptions" :key="index" :label="item" :value="item" />
                  </el-select>
                </el-form-item>
                <el-form-item label="关键字" class="formItem">
                  <el-input v-model="zhiform.keyword" placeholder="请输入应用名称/APPID" />
                </el-form-item>
                <el-form-item label="状态" class="formItem">
                  <el-select v-model="zhiform.status" placeholder="请选择">
                    <el-option label="全部" value="" />
                    <el-option label="待处理" value="1" />
                    <el-option label="已绑定" value="2" />
                    <el-option label="已禁用" value="3" />
                    <el-option label="已拒绝" value="-1" />
                  </el-select>
                </el-form-item>
                <div class="formItem operate">
                  <el-button type="primary" @click="queryzhi(1)">查询</el-button>
                  <el-button @click="zhiresetForm">重置</el-button>
                  <el-button v-if="powerReg('f347014fff59ae1ac288ba25c459bb44')" type="primary" @click="add('zhi')"><i class="el-icon-plus" />添加绑定</el-button>
                  <el-button class="ml20" type="primary" @click="exportFn">导出</el-button>
                </div>
              </div>
            </el-form>
          </div>
        </div>
        <zf-table
          :columns="zhicolumn"
          :data-source="zhitableList"
          :total="zhipages.total"
          :page-size="zhipages.pageSize"
          :page-num="zhipages.page"
          @change="handlezhiPageChange"
        >
          <template
            slot="logo_url"
            slot-scope="{ row }"
          >
            <div v-if="row.logo_url" class="flex_between">
              <img class="shadow" :src="`${baseUrl}${row.logo_url}`">
            </div>
            <span v-else>-</span>
          </template>
          <!-- APPID -->
          <template
            slot="appid"
            slot-scope="{ row }"
          >
            <span v-if="row.appid">{{ row.appid }}</span>
            <span v-else>-</span>
          </template>
          <template
            slot="download_url"
            slot-scope="{ row }"
          >
            <div v-if="row.download_url" class="flex_between">
              <span :title="row.download_url" class="ellipsis">{{ row.download_url }}</span>
              <el-link v-clipboard:copy="row.download_url" v-clipboard:success="onCopy" type="primary" :underline="false" style="width:56px;flex-shrink: 0;">复制</el-link>
            </div>
            <span v-else>-</span>
          </template>
          <template
            slot="app_user_agreement_url"
            slot-scope="{ row }"
          >
            <div v-if="row.app_user_agreement_url" class="flex_between">
              <span :title="row.app_user_agreement_url" class="ellipsis">{{ row.app_user_agreement_url }}</span>
              <el-link v-clipboard:copy="row.app_user_agreement_url" v-clipboard:success="onCopy" type="primary" :underline="false" style="width:56px;flex-shrink: 0;">复制</el-link>
            </div>
            <span v-else>-</span>
          </template>
          <template
            slot="status"
            slot-scope="{ row }"
          >
            <span v-if="row.status == 1" class="wait_bg plub_width inline">待处理</span>
            <span v-if="row.status == 2" class="ableuse_bg plub_width inline">已绑定</span>
            <span v-if="row.status == 3" class="no_bg plub_width inline" style="width:74px">已禁用 <el-tooltip class="item" effect="dark" content="该APPID已被平台方禁止付款，有疑问请及时联系平台方。" placement="top-end">
              <i style="color:black;" class="el-icon-warning" />
            </el-tooltip></span>
            <span v-if="row.status == -1" class="nouse_bg plub_width inline">已拒绝</span>
          </template>
          <!-- 拒绝原因 -->
          <template
            slot="reject_msg"
            slot-scope="{ row }"
          >
            <span v-if="row.status == -1">{{ row.reject_msg }}</span>
            <span v-else>-</span>
          </template>
          <!-- 操作 -->
          <template
            slot="action"
            slot-scope="{ row }"
          >
            <a v-if="row.status == 1" class="del" @click="backout(row)">撤销</a>
            <a class="active_color" @click="app_mch_info(row)">详情</a>
          </template>
        </zf-table>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :title="mode === 1 ? '添加' : '详情'" :visible.sync="addFormVisible" width="760px" center>
      <el-form ref="addForm" :model="addForm" label-width="120px" class="addForm" :rules="rules">
        <el-row class="width100">
          <el-col :span="12">
            <el-form-item label="客户名称">
              {{ company_name }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应用名称" prop="app_name" v-if="mode === 1">
              <el-input v-model="addForm.app_name" />
            </el-form-item>
            <el-form-item label="应用名称" prop="app_name" v-else>
              {{ addForm.app_name }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="width100">
          <el-col :span="12">
            <el-form-item v-if="activeName == '1' && mode === 1" label="微信APPID" prop="appid">
              <el-input v-model.trim="addForm.appid" />
<!--              <el-input v-model.trim="addForm.appid" style="width: 170px;"/>-->
<!--              <span class="active_color ml10 pointer fs12" @click="createAppid('wx')">随机生成</span>-->
            </el-form-item>
            <el-form-item v-if="activeName == '2' && mode === 1" label="支付宝APPID" prop="appid">
              <el-input v-model.trim="addForm.appid" style="width: 170px;"/>
              <span class="active_color ml10 pointer fs12" @click="createAppid('10')">随机生成</span>
            </el-form-item>
            <el-form-item label="APPID" prop="appid" v-if="mode === 2">
              {{ addForm.appid }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司主体" prop="main_company_name" v-if="mode === 1">
              <el-input v-model="addForm.main_company_name" />
            </el-form-item>
            <el-form-item label="公司主体" prop="main_company_name" v-else>
              {{ addForm.main_company_name }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="width100">
          <el-col :span="12">
            <el-form-item label="商户号" prop="mch" v-if="mode === 1">
              <el-select v-model="addForm.mch" placeholder="请选择">
                <el-option v-if="activeName == '1'" v-for="item in wxOptions" :key="item" :label="item" :value="item" />
                <el-option v-if="activeName == '2'" v-for="item in aliOptions" :key="item" :label="item" :value="item" />
              </el-select>
            </el-form-item>
            <el-form-item label="商户号" prop="mch" v-else>
              {{ addForm.mch }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="应用类型" prop="app_type" v-if="mode === 1">
              <el-select v-model="addForm.app_type" placeholder="请选择">
                <el-option v-for="item in app_type_list" :key="item.app_type" :label="item.name" :value="item.app_type" />
              </el-select>
            </el-form-item>
            <el-form-item label="应用类型" prop="app_type" v-else>
              {{app_type_list.find(item => item.app_type == addForm.app_type).name}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="width100">
          <el-col :span="12" v-if="activeName == '1'">
            <el-form-item label="授权登录" prop="is_oauth" v-if="mode === 1">
              <el-select v-model="addForm.is_oauth" placeholder="请选择">
                <el-option v-for="item in is_oauth_list" :key="item.is_oauth" :label="item.name" :value="item.is_oauth" />
              </el-select>
            </el-form-item>
            <el-form-item label="授权登录" prop="is_oauth" v-else>
              {{is_oauth_list.find(item => item.is_oauth == addForm.is_oauth).name}}
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="activeName == '1' && addForm.is_oauth == 1">
            <el-form-item label="每日授权限制" prop="oauth_limit_day" style="position: relative;" v-if="mode === 1">
              <el-input v-model="addForm.oauth_limit_day" type="number" />
              <span slot="label">每日授权限制<i class="el-icon-info" title="同一个账号每日可绑定的用户数量，-1为无限制，0为不允许绑定，其他为可绑定数量"></i></span>
            </el-form-item>
            <el-form-item label="每日授权限制" prop="oauth_limit_day" style="position: relative;" v-else>
              {{addForm.oauth_limit_day}}
              <span slot="label">每日授权限制<i class="el-icon-info" title="同一个账号每日可绑定的用户数量，-1为无限制，0为不允许绑定，其他为可绑定数量"></i></span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="width100" v-if="activeName == '1' && addForm.is_oauth == 1">
          <el-col :span="12" v-if="activeName == '1' && addForm.is_oauth == 1">
            <el-form-item label="累计授权限制" prop="oauth_limit_total" style="position: relative;" v-if="mode === 1">
              <el-input v-model="addForm.oauth_limit_total" type="number" />
              <span slot="label">累计授权限制<i class="el-icon-info" title="同一个账号累计可绑定的用户数量，-1为无限制，0为不允许绑定，其他为可绑定数量"></i></span>
            </el-form-item>
            <el-form-item label="累计授权限制" prop="oauth_limit_total" style="position: relative;" v-else>
              {{addForm.oauth_limit_total}}
              <span slot="label">累计授权限制<i class="el-icon-info" title="同一个账号累计可绑定的用户数量，-1为无限制，0为不允许绑定，其他为可绑定数量"></i></span>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="mode == 2 && addForm.is_oauth == 1">
            <el-form-item label="授权应用" prop="hf_appid">
              {{ addForm.hf_appid }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="width100" v-if="mode == 2 && addForm.is_oauth == 1">
          <el-col :span="12">
            <el-form-item label="原始ID" prop="gh_id">
              {{ addForm.gh_id }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="授权页面" prop="path">
              {{ addForm.path }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="width100">
          <el-col :span="24">
            <el-form-item label="	应用下载链接" prop="download_url" v-if="mode === 1">
              <el-input v-model="addForm.download_url" />
            </el-form-item>
            <el-form-item label="	应用下载链接" prop="download_url" v-else>
              {{ addForm.download_url }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="width100">
          <el-col :span="24">
            <el-form-item label="	APP用户协议" prop="app_user_agreement_url" v-if="mode === 1">
              <el-input v-model="addForm.app_user_agreement_url" />
            </el-form-item>
            <el-form-item label="	APP用户协议" prop="app_user_agreement_url" v-else>
              {{ addForm.app_user_agreement_url }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="type == 'zhi'" class="width100">
          <el-col :span="24">
            <el-form-item label="应用图标" prop="logo_url" :rules="{ required: true, message: '请上传应用图标', trigger: 'change' }">
              <el-upload
                action="#"
                :auto-upload="true"
                :before-upload="beforeUploadFile"
                :http-request="doUploadFile"
                :multiple="false"
                :limit="1"
                :on-exceed="handleExceed"
                :on-remove="handleRemove"
                :file-list="fileList"
                list-type="picture-card"
              >
                <i class="el-icon-plus" />
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button v-if="mode === 1" type="primary" @click="submitFn('addForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ZfTable from '@/components/ZfTable/CoreTable'
import column from './columns/list'
import zhicolumn from './columns/zhilist'
import { appidBindMchList, appidBindMch, rebackApply, exportListAppid, appidDetail } from '@/api/mch'
import { getMchList, uploadFile } from '@/api/common'
import exportFiles from '@/utils/exportFile'
import { get } from '@/utils/storage'
// import Comcompany from '@/components/companyNew'
import { isPuXing } from '@/utils/fn'
import {range} from "element-ui";
export default {
  name: 'List',
  components: {
    ZfTable,
    // Comcompany
  },
  data() {
    return {
      column,
      zhicolumn,
      company_name: JSON.parse(get('userinfo')).company_name,
      form: {
        keyword: '',
        status: ''
      },
      zhiform: {
        keyword: '',
        status: ''
      },
      pages: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      zhipages: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      tableList: [], // 客户列表
      zhitableList: [], // 客户列表
      addFormVisible: false,
      addForm: {
        app_name: '',
        appid: '',
        mch: '',
        main_company_name: '',
        download_url: '',
        app_user_agreement_url: '',
        app_type: '',
        is_oauth: 0,
        oauth_limit_day: -1,
        oauth_limit_total: -1,
        logo_url: null
      },
      options: [],
      wxOptions: [],
      aliOptions: [],
      optionArr: [],
      app_type_list: [{'app_type':1, 'name':'移动应用'}, {'app_type':2, 'name':'小程序'}, {'app_type':3, 'name':'公众号'}, {'app_type':4, 'name':'小游戏'}, {'app_type':5, 'name':'H5应用'}, {'app_type':0, 'name':'其他'}],
      is_oauth_list: [{'is_oauth':0, 'name':'否'}, {'is_oauth':1, 'name':'是'}],
      mode: 1,
      id: '',
      rules: {
        app_name: [
          { required: true, message: '请输入应用名称', trigger: 'blur' }
        ],
        appid: [
          { required: true, message: '请输入APPID', trigger: 'blur' }
        ],
        mch: [
          { required: true, message: '请选择商户号', trigger: 'blur' }
        ],
        main_company_name: [
          { required: true, message: '请输入公司主体', trigger: 'blur' }
        ],
        app_type: [
          { required: true, message: '请选择应用类型', trigger: 'blur' }
        ],
        download_url: [
          { required: true, message: '请输入应用下载地址', trigger: 'blur' }
        ],
        app_user_agreement_url: [
          { required: true, message: '请输入APP用户协议链接', trigger: 'blur' }
        ]
      },
      activeName: '1',
      type: null,
      fileList: [],
      baseUrl: ''
    }
  },
  mounted() {
    getMchList({ company_id: JSON.parse(get('userinfo')).company_id, type: 1 }).then(res => {
      if (res.code === 200) {
        this.wxOptions = res.data
      }
    })
    getMchList({ company_id: JSON.parse(get('userinfo')).company_id, type: 2 }).then(res => {
      if (res.code === 200) {
        this.aliOptions = res.data
      }
    })
    this.query(1)
  },
  created() {
    if (process.env.NODE_ENV === 'development') {
      if (isPuXing()) {
        this.baseUrl = process.env.VUE_APP_PUXING_BASE_API
      } else {
        this.baseUrl = process.env.VUE_APP_BASE_API
      }
    } else {
      this.baseUrl = process.env.VUE_APP_BASE_API
    }
  },
  methods: {
    async query(pg) {
      if (this.activeName === '2') {
        this.queryzhi(1)
        return
      }
      this.pages.page = pg
      const query = { ...this.pages, ...this.form, type: this.activeName }
      const res = await appidBindMchList(query)
      if (res.code === 200) {
        this.tableList = res.data.data
        this.pages.total = res.data.total
      }
    },
    async queryzhi(pg) {
      this.zhipages.page = pg
      const query = { ...this.zhipages, ...this.zhiform, type: this.activeName }
      const res = await appidBindMchList(query)
      if (res.code === 200) {
        this.zhitableList = res.data.data
        this.zhipages.total = res.data.total
      }
    },
    resetForm() {
      this.form = {
        keyword: '',
        status: ''
      }
      this.query(1)
    },
    zhiresetForm() {
      this.zhiform = {
        keyword: '',
        status: ''
      }
      this.queryzhi(1)
    },
    handlePageChange({ pageNum, pageSize, sorter: { prop, order }}) {
      this.pages.page = pageNum
      this.pages.pageSize = pageSize
      this.query(this.pages.page)
    },
    handlezhiPageChange({ pageNum, pageSize, sorter: { prop, order }}) {
      this.zhipages.page = pageNum
      this.zhipages.pageSize = pageSize
      this.queryzhi(this.zhipages.page)
    },
    backout(row) {
      this.$confirm('确认撤销？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rebackApply({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.$message({ type: 'success', message: '操作成功' })
            this.query(1)
          }
        })
      })
    },
    async app_mch_info(row) {
      const res = await appidDetail({ id: row.id })
      if (res.code === 200) {
        this.id = row.id
        this.mode = 2
        this.addForm = {
          ...this.addForm,
          ...res.data
        }
        this.addFormVisible = true
      }
    },
    add(type) {
      this.type = type
      this.mode = 1
      this.id = ''
      this.addFormVisible = true
      this.addForm.app_name = ''
      this.addForm.appid = ''
      this.addForm.mch = ''
      this.addForm.main_company_name = ''
      this.addForm.download_url = ''
      this.addForm.app_type = ''
      this.addForm.is_oauth = 0
      this.addForm.oauth_limit_day = -1
      this.addForm.oauth_limit_total = -1
      this.addForm.logo_url = ''
      this.fileList = []
    },
    async submitFn(formName) {
      const valid = await this.$refs[formName].validate()
      if (!valid) return
      // if (this.addForm.type == 2) {
      //   delete this.addForm.appid
      // }
      const res = await appidBindMch({ ...this.addForm, mch: Array.isArray(this.addForm.mch) ? this.addForm.mch.join(',') : this.addForm.mch, type: this.activeName })
      if (res.code === 200) {
        this.$message.success('添加成功')
        this.addFormVisible = false
        this.query(1)
        this.fileList = []
      }
    },
    onCopy(e) {
      this.$message.info(`复制成功：${e.text}`)
    },
    // exportFn() {
    //   if(isPuXing()){
    //    window.open(`${process.env.VUE_APP_PUXING_BASE_API}/webapi/mch/exportList?keyword=${this.form.keyword}&status=${this.form.status}&company_id=${JSON.parse(get('userinfo')).company_id}`)
    //   }else{
    //     window.open(`${process.env.VUE_APP_BASE_API}/webapi/mch/exportList?keyword=${this.form.keyword}&status=${this.form.status}&company_id=${JSON.parse(get('userinfo')).company_id}`)
    //   }
    //   },
    async exportFn() {
      var res = await exportListAppid({
        keyword: this.form.keyword,
        // company_id: JSON.parse(get('userinfo')).company_id,
        status: this.form.status
      })
      if (res.type !== 'application/json') {
        exportFiles(res, 'APPID', 'xls')
      }
    },
    handleClick(tab) {
      this.$refs.addForm && (this.$refs.addForm.resetFields())
      this.query(1)
    },
    beforeUploadFile(file) {
      const type = /^(.pdf|.jpg|.png)$/.test(file.name.slice(file.name.lastIndexOf('.')))
      const size = file.size / 1024 / 1024 < 20
      if (!type) {
        this.$message('不支持该文件类型,请重新选择')
      }
      if (!size) {
        this.$message('文件大小不可超过20MB')
      }
      return type && size
    },
    doUploadFile(file) {
      console.log(file, 'file')
      const params = new FormData()
      params.append('file', file.file)
      uploadFile(params).then(res => {
        if (res.code === 200) {
          this.addForm.logo_url = res.data
        }
      })
    },
    handleExceed() {
      this.$message('最多可上传1个文件')
    },
    handleRemove() {
      this.addForm.logo_url = ''
    },
    createAppid($prefix = '10') {
      var currentDate = new Date()
      var year = (currentDate.getUTCFullYear()-2000).toString().padStart(2, '0')
      var month = (currentDate.getMonth() + 1).toString().padStart(2, '0') // 月份从0开始，所以要加1
      var day = currentDate.getDate().toString().padStart(2, '0')
      var hour = currentDate.getHours().toString().padStart(2, '0')
      var minute = currentDate.getMinutes().toString().padStart(2, '0')
      var randomNum = Math.floor(1000 + Math.random() * 9000).toString()
      this.addForm.appid = $prefix + year + month + day + hour + minute + randomNum
    }
  }
}
</script>

<style scoped>
>>>.el-upload--picture-card,
>>>.el-upload-list__item{
  width: 100px;
  height: 100px;
  line-height: 110px;
}
</style>

<style lang="scss" scoped>
.right{
  display: flex;
  align-items:flex-start;
  margin-bottom: 22px;
}
// .formItem{
//   width: calc( 40% - 24px);
// }
.shadow {
  width: 55px;
  margin: 0 auto;
}
::v-deep{
  .addForm{
    .el-input{
      width: 214px;
    }
    .width100{
      .el-input{
        width: 100%;
      }
      .el-select{
        width: 100%;
      }
    }
  }
}
</style>
